import React from "react";
import _authIcon from "../../../componets/json/authIcon";
import { Row, Col, Form, Button, InputGroup, Alert } from "react-bootstrap";

class VodafoneAuthorization extends React.Component {
    state = {
        authkey: localStorage.getItem("vdf_key"),
        countTry: 0,
        isInvalid: false,
        isValid: false,
        alert: {
            variant: "",
            text: ""
        }
    }
    componentDidMount() {
        this.props.setHeaderPage({
            Icon: _authIcon("SiVodafone", "c-placeholder c-red"),
            Title: "Vodafone autorizace",
            SubTitle: "",
        });

        if (this.state.authkey != null) this.authSet();

        let deny = localStorage.getItem("vdf_key_1");
        if (deny != null) this.props.setNavigate("/")
    }

    authSet = () => {
        if (process.env.REACT_APP_VDF_KEY != this.state.authkey) {
            this.setState({ isInvalid: true, countTry: (this.state.countTry + 1), alert: { variant: "danger", text: "Nesprávný autorizační kód." } });
        }

        if (process.env.REACT_APP_VDF_KEY == this.state.authkey) {
            this.setState({
                isValid: true, alert: {
                    variant: "success", text: <Row><Col xs={12} className="d-flex justify-content-between"><span>Autorizační kód byl nastaven</span><span>
                        <a href="javascript:" onClick={() => this.props.setNavigate("/repair/vodafone")} className="btn btn-light">Přejít na zadání požadavku</a>
                    </span>
                    </Col></Row>
                }
            });
            localStorage.setItem("vdf_key", this.state.authkey);
        }

        if (this.state.countTry == 3) {
            localStorage.setItem("vdf_key_1", "");
            this.props.setNavigate("/")
        }
    }


    render() {
        return (<>
            {this.state.alert.text && (
                <Row>
                    <Col>
                        <Alert variant={this.state.alert.variant}>
                            {this.state.alert.text}
                        </Alert>
                    </Col>
                </Row>
            )}

            <Row>
                <Col>
                    <Form.Text>Zbývá {(3 - this.state.countTry)} pokus/y</Form.Text>
                    <InputGroup>
                        <Form.Control disabled={this.state.isValid} type="password" isInvalid={this.state.isInvalid} isValid={this.state.isValid} value={this.state.authkey} onChange={(e) => this.setState({ authkey: e.target.value })} />
                        <Button disabled={this.state.isValid} variant="success" size="sm" onClick={this.authSet}>Autorizovat</Button>
                    </InputGroup>

                    <Form.Text>Autorizační kód</Form.Text>
                </Col>
            </Row>
        </>)
    }
}

export default VodafoneAuthorization;